import { ChainID, ChainType } from '@ankr.com/chains-list';

import { ChainGroupID } from 'modules/endpoints/types';

export const getInitSelectedGroupId = (
  chainId: ChainID,
  chainType: ChainType,
) => {
  if (chainId === ChainID.BTC && chainType === ChainType.Testnet) {
    return ChainGroupID.BTC;
  }

  return undefined;
};
